<div class="PGSwitch {{small ? 'PGSwitch--Small' : ''}} {{little ? 'PGSwitch--Little' : ''}} {{readonly ? 'PGSwitch--Readonly' : ''}} {{value != null ? 'PGSwitch--HasValue' : ''}} {{selected ? 'PGSwitch--Selected bg-' + getSelectedColorClass() : 'bg-secondary'}}"
    [attr.role]="value != null ? 'radio' : 'switch'"
    [attr.aria-checked]="!!selected"
    [attr.aria-disabled]="readonly || null"
    [attr.tabindex]="readonly ? -1 : 0"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="ariaLabelledBy || null"
    (click)="toggleSwitch()"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event)">
    <input type="checkbox" [attr.id]="fieldId || null" [disabled]="readonly" [ngModel]="selected" (ngModelChange)="setSwitch($event)" tabindex="-1" aria-hidden="true"/>
    <div class="PGSwitch-Selector {{isAnimated ? 'PGSwitch-Selector--Animated' : '' }}" aria-hidden="true">
        @if (little && value == null) {
            <i class="fa-solid fa-check d-block"></i>
        }
    </div>
</div>
